import { AccreditationFields, Event } from "@/types/event";
import { User } from "./user";

export type Fields = {
  accreditationField: AccreditationFields;
  value: JSON;
};

export type Accreditation = {
  fields: AccreditationFields[];
  id: number;
  status: AccreditationTypes;
  user: User;
  event: Event;
};

export enum AccreditationTypes {
  PENDING = "pending",
  CANCELED = "canceled",
  INCOMPLETE = "incomplete",
  REJECTED = "rejected",
  GRANTED = "granted",
  WITHDRAWN = "withdrawn",
}

export enum ApplicationListStatuses {
  GRANTED = "granted",
  PENDING = "pending",
  OTHER = "other",
}
